import './SpokenLanguage.sass';

import React, { FC } from 'react';
import { useSelector } from 'react-redux';

import { SpokenLanguageProps } from './SpokenLanguage.interface';
import { useTranslator } from '$hooks';
import { mainSelector } from '$store/main';
import { LANGUAGE_MAP } from '$shared/constants/languages';

export const SpokenLanguage: FC<SpokenLanguageProps> = ({ user }) => {
  const t = useTranslator();
  const { mVerified } = useSelector(mainSelector);

  const code = user?.lang;
  const fallback =
    code && code in LANGUAGE_MAP ? LANGUAGE_MAP[code as keyof typeof LANGUAGE_MAP] : null;
  const label = fallback ? t(`language_${code}`, { defaultValue: '' }) || fallback : null;

  if (!mVerified || !label) {
    return null;
  }

  return <span className="SpokenLanguage">{label}</span>;
};
